export function stripNonDigits(prevValue: string, value: string, maxValue: number): string {
  const strippedValue = value.replaceAll(/\D/g, '');
  if (strippedValue === '') {
    return '';
  }
  if (strippedValue.length > maxValue) {
    return prevValue;
  }
  return strippedValue;
}
